import React, { useState, useContext, useEffect } from 'react';
import { Form, Input, Button, Card, Typography, Alert, Checkbox } from 'antd';
import { PhoneOutlined, LockOutlined } from '@ant-design/icons';
import { AuthContext } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';

const { Title, Text } = Typography;

const Login = () => {
  const [form] = Form.useForm();
  const { login, isAuthenticated, error, clearError } = useContext(AuthContext);
  const navigate = useNavigate();
  const [loginInProgress, setLoginInProgress] = useState(false);

  // 如果已经登录，重定向到主页
  useEffect(() => {
    console.log('Login组件状态:', { isAuthenticated, error });
    
    if (isAuthenticated) {
      console.log('用户已认证，跳转到首页');
      navigate('/');
    }
  }, [isAuthenticated, navigate, error]);

  // 从localStorage获取记住的用户信息
  useEffect(() => {
    const rememberedPhone = localStorage.getItem('rememberedPhone');
    
    if (rememberedPhone) {
      form.setFieldsValue({ 
        phone: rememberedPhone,
        remember: true 
      });
    }
  }, [form]);

  // 在登录页面加载时清除考试结果缓存
  useEffect(() => {
    localStorage.removeItem('examResult');
  }, []);

  // 提交表单
  const onFinish = async (values) => {
    const { phone, password, remember } = values;
    
    // 如果选择记住我，保存用户信息到localStorage
    if (remember) {
      localStorage.setItem('rememberedPhone', phone);
    } else {
      localStorage.removeItem('rememberedPhone');
    }
    
    // 设置登录中状态
    setLoginInProgress(true);
    
    console.log('提交登录请求:', { phone });
    
    // 使用手机号登录
    const loginParams = {
      phone,
      password
    };

    console.log('详细的登录参数:', loginParams);

    // 登录
    try {
      const result = await login(loginParams);
      
      if (result.success) {
        console.log('登录请求完成');
        navigate('/selection');
      } else {
        console.error('登录过程中发生错误:', result.message || '登录失败');
        setLoginInProgress(false);
      }
    } catch (error) {
      console.error('登录过程中发生错误:', error);
      setLoginInProgress(false);
    }
  };

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh',
      background: '#f0f2f5'
    }}>
      <Card style={{ width: 400, boxShadow: '0 4px 8px rgba(0,0,0,0.1)' }}>
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <Title level={2}>安全培训考试系统</Title>
          <Title level={4}>用户登录</Title>
        </div>
        
        {error && (
          <Alert
            message="登录失败"
            description={error}
            type="error"
            showIcon
            closable
            style={{ marginBottom: 24 }}
            onClose={clearError}
          />
        )}
        
        <Form
          form={form}
          name="login"
          onFinish={onFinish}
          autoComplete="off"
          layout="vertical"
        >
          <Form.Item
            name="phone"
            rules={[
              { required: true, message: '请输入手机号!' },
              { pattern: /^1[3-9]\d{9}$/, message: '手机号格式不正确!' }
            ]}
          >
            <Input 
              prefix={<PhoneOutlined />} 
              placeholder="手机号" 
              size="large" 
            />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[{ required: true, message: '请输入密码!' }]}
          >
            <Input.Password 
              prefix={<LockOutlined />} 
              placeholder="密码" 
              size="large" 
            />
          </Form.Item>

          <Form.Item name="remember" valuePropName="checked">
            <Checkbox>记住我</Checkbox>
          </Form.Item>

          <Form.Item>
            <Button 
              type="primary" 
              htmlType="submit" 
              block 
              size="large"
              loading={loginInProgress}
            >
              登录
            </Button>
          </Form.Item>
          
          <div style={{ textAlign: 'center' }}>
            <Text type="secondary">使用手机号和密码登录</Text>
          </div>
        </Form>
      </Card>
    </div>
  );
};

export default Login; 